import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'tudi-image-file-selector',
  templateUrl: './image-file-selector.component.html',
  styleUrls: ['./image-file-selector.component.scss']
})
export class ImageFileSelectorComponent {
  @Output() onUpload: EventEmitter<File> = new EventEmitter();

  image: File;
  displayDataUrl: string;

  async uploadPhoto(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    this.image = input.files?.[0];
    const reader = new FileReader();
    reader.onload = (event:any) => {
      this.displayDataUrl = event.target.result;
    }
    reader.readAsDataURL(this.image);
    this.onUpload.emit(this.image);
  }

  show(): void {
    document.getElementById('FileUploader').click();
  }

  clear(): void {
    this.image = null;
    this.displayDataUrl = null;
  }
}
